<template>
  <onboarding-plans v-model="selectedPriceId">
    <template #bottom="{ plans, commercialProducts, editorialProducts, terms, selectedPlanType, currentSelectOptionTitle, selectedSubscription, planPrices }">
      <div class="tw-flex tw-justify-end tw-mt-4">
        <button type="button" class="btn btn-primary btn-rounded"
                :disabled="selectedPlanType === null"
                @click="handleContinueButton">
        <span class="tw-flex tw-items-center tw-justify-center">
          <span class="tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-semibold tw-mr-2">Continue</span>
          <i class="fas fa-arrow-right tw-text-sm"></i>
        </span>
        </button>
      </div>

      <b-modal size="lg" v-model="showPaymentModal" hide-footer lazy hide-header>
        <onboarding-payment-modal :show-payment-modal="showPaymentModal"
                                  :select-title="currentSelectOptionTitle(selectedPlanType)"
                                  :prices="planPrices(selectedPlanType)"
                                  :agreement="terms"
                                  :selected-subscription="selectedSubscription"
                                  v-model="selectedPriceId"/>
      </b-modal>

      <b-modal size="md" v-model="showSignupModal" hide-footer lazy hide-header>
        <div class="tw-p-4">
          <sign-up-form @close="showSignupModal = false"/>
        </div>
      </b-modal>
    </template>
  </onboarding-plans>
</template>
<script>
import OnboardingPlans from "./OnboardingPlans.vue";
import OnboardingPaymentModal from "./OnboardingPaymentModal.vue";
import SignUpForm from "./SignUpForm.vue";

export default {
  components: {SignUpForm, OnboardingPaymentModal, OnboardingPlans},
  data() {
    return {
      showPaymentModal: false,
      selectedPriceId: null,
      showSignupModal: false,
    }
  },

  methods: {
    handleContinueButton() {
      if (this.selectedPriceId === "on_demand") {
        // $('#pricingRegisterModal').modal('show')
        this.showSignupModal = true
      } else {
        this.showPaymentModal = true
      }
    },
  }
}
</script>